import React, { useContext, useEffect, useState } from "react";
import { Alert, Dialog, Table } from "../../layout";
import { Button } from "../../controls";
import { Avatar, IconButton, Tooltip } from "@mui/material";
import {
  ClearRounded,
  EditRounded,
  StopCircleRounded,
  VisibilityRounded,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import ViewUser from "./ViewUser";
import { AppContext } from "../../App";
import { API, actions, endpoints } from "../../api/api";
import { DropLi } from "../../hooks";
import moment from "moment";
import { useTranslation } from "react-i18next";

const Users = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { branch, setLoader } = useContext(AppContext);
  const [users, setUsers] = useState([]);
  const [viewUser, setViewUser] = useState(false);
  const [viewData, setViewData] = useState();
  const { Role } = DropLi();
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  const handleAddEdit = (id) => {
    navigate(`/user_form/${id || ""}`);
  };

  const handleView = (data) => {
    setViewUser(true);
    setViewData(data);
  };

  const handleDlt = (id) => {
    if (id) {
      setAlert({
        isOpen: true,
        type: "confirmation",
        title: t("CfmTitle"),
        subTitle: t("InvDltTitle"),
        onConfirm: () => {
          const onComplete = (res) => {
            if (res.status === 200) {
              setAlert({
                isOpen: true,
                type: "success",
                title: t("DltSuccessTitle"),
                subTitle: res.msg,
              });
              setUsers((x) => [...x.filter((j) => j.id !== res.result.id)]);
            } else {
              setAlert({
                isOpen: true,
                type: "warning",
                title: t("Warning"),
                subTitle: res.msg,
              });
            }
          };
          API(endpoints.User).Delete(id, onComplete);
        },
      });
    }
  };

  const handleAccStatus = (user) => {
    if (user && user.id) {
      var status = user.accStatus === "Active" ? t("Inactive") : t("Active");
      setAlert({
        isOpen: true,
        type: "confirmation",
        title: t("CfmTitle"),
        subTitle: `${
          t("UserStatusChgMsg1") + " " + status + " " + t("UserStatusChgMsg2")
        }`,
        onConfirm: () => {
          const onComplete = (res) => {
            if (res && res.status === 200) {
              setAlert({
                isOpen: true,
                type: "success",
                title: `${status + " " + t("Successfully")}`,
                subTitle: res.msg,
              });
              setUsers((x) => [
                ...x.map((j) => (j.id === res.result.id ? res.result : j)),
              ]);
            } else if (res) {
              setAlert({
                isOpen: true,
                type: "warning",
                title: t("Warning"),
                subTitle: res.msg,
              });
            }
          };
          API(endpoints.User + actions.ChangeAccStatus).getById(
            user.id,
            onComplete
          );
        },
      });
    }
  };

  useEffect(() => {
    setLoader(true);
    if (branch.id) {
      API(endpoints.User + actions.GetAllByBranch).getById(branch.id, (res) => {
        res.status === 200 && setUsers([...res.result]);
        setLoader(false);
      });
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branch]);

  const ActionComp = (props) => (
    <div className="bs-secondary br-8 p-5 w-fit p-2">
      <Tooltip title={t("View")}>
        <IconButton
          onClick={() => handleView(props)}
          size="small"
          color="primary"
          className="mr-5"
        >
          <VisibilityRounded className="fs-20 m-2" />
        </IconButton>
      </Tooltip>
      <Tooltip title={t("StopAccess")}>
        <IconButton
          onClick={() => handleAccStatus(props)}
          size="small"
          color="primary"
          className="mr-5 p-5"
        >
          <StopCircleRounded className="fs-20 m-2" />
        </IconButton>
      </Tooltip>
      <Tooltip title={t("Edit")}>
        <IconButton
          onClick={() => handleAddEdit(props.id)}
          size="small"
          color="primary"
          className="mr-5 p-5"
        >
          <EditRounded className="fs-20 m-2" />
        </IconButton>
      </Tooltip>

      <Tooltip title={t("Delete")}>
        <IconButton
          onClick={() => handleDlt(props.id)}
          size="small"
          color="error"
          className="mr-5 p-5"
        >
          <ClearRounded className="fs-20 m-2" />
        </IconButton>
      </Tooltip>
    </div>
  );
  const HeaderComp = () => (
    <div>
      <Button onClick={() => handleAddEdit()}>{t("AddUser")}</Button>
    </div>
  );
  return (
    <>
      <Table
        ActionComp={ActionComp}
        HeaderComp={HeaderComp}
        tblHead={[
          { id: "user", label: t("User") },
          { id: "username", label: t("Username") },
          { id: "contact", label: t("Contact") },
          { id: "age", label: t("Age") },
          { id: "lastVisit", label: t("LastVisit") },
          { id: "actions", label: t("Actions") },
        ]}
        tblData={users.map((j) => {
          var role = Role.find((x) => x.id === j.role);
          var accStatus = j.accStatus === 1 ? t("Active") : t("Inactive");
          return {
            ...j,
            accStatus: accStatus,
            user: (
              <div className="d-flex mt-5 mb-5">
                <div className="mr-20">
                  <Avatar src={j.photo} className="shadow-lg" />
                </div>
                <div className="d-grid">
                  <span
                    className="fw-5 primary-color c-pointer mb-3"
                    onClick={() => handleView()}
                  >
                    {j.firstName + " " + j.lastName}
                  </span>
                  {j.accStatus === 1 ? (
                    <span className="fs-12 fw-5 bg-success white-color pl-5 pr-5 pt-2 pb-2 w-fit br-8 tx-upp">
                      {t("Active")}
                    </span>
                  ) : (
                    <span className="fs-12 fw-5 bg-error white-color pl-5 pr-5 pt-2 pb-2 w-fit br-8 tx-upp">
                      {t("Inactive")}
                    </span>
                  )}
                </div>
              </div>
            ),
            username: (
              <div className="d-grid ">
                <span className="fs-16 fw-5 gray-color c-pointer">
                  {j.email}
                </span>
                <span className="fs-12 fw-4 gray-color c-pointer">
                  {role && role.label}
                </span>
              </div>
            ),
            contact: (
              <div className="d-grid">
                <a
                  className="fs-14 primary-color c-pointer mb-3"
                  href={`mailto:${j.email}`}
                >
                  ✉️ {j.email}
                </a>
                <a
                  className="fs-14 primary-color c-pointer"
                  href={`tel:${j.phone}`}
                >
                  📞 {j.phone}
                </a>
              </div>
            ),
            age: (
              <div className="d-grid ">
                <span className="fs-16 fw-5 gray-color c-pointer">
                  {j.dob && moment().diff(moment(j.dob, "MM/DD/YYYY"), "years")}
                </span>
                <span className="fs-12 fw-4 gray-color c-pointer">{j.dob}</span>
              </div>
            ),
            lastVisit: (
              <span className="fs-16 fw-4 gray-color c-pointer">
                {j.lastVisit}
              </span>
            ),
          };
        })}
      />

      {/* View Details */}
      {viewUser && (
        <Dialog show={viewUser} onClose={false} maxWidth="md">
          <ViewUser {...{ setShowForm: setViewUser, viewData }} />
        </Dialog>
      )}

      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

export default Users;
